import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {AuthenticationService} from "../../shared/authentication.service";
import {ModalService} from "../../shared/modal.service";
import {Company} from "../../shared/api/companies/api.models";
import {Api} from "../../shared/api.service";
import {Utils} from "../../shared/utils.service";
import {Me} from "../../shared/api/me/me.models";
import {CompanyModal} from "./components/company.modal";

@Component({
    selector: 'settings-users',
    template: require('./companies.component.html'),
    styles: [require('./companies.component.scss')]
})

export class CompaniesComponent implements OnInit {
    protected companies: Company[];
    protected me: Me;
    protected filter: any = {
        name: null,
        description: null,
        manager: null
    };

    constructor(
        private route: ActivatedRoute,
        private utils: Utils,
        private modal: ModalService,
        private api: Api,
        private auth: AuthenticationService
    ) {}

    ngOnInit() {
        this.companies = this.route.snapshot.data['companies'];
        this.utils.sortList(this.companies, 'name');
        this.me = this.auth.getMe();
    }

    new() {
        let company = new Company();

        this.openModal(company).then(
            (company: Company) => {
                this.companies.push(company);
                this.utils.sortList(this.companies, 'name');
            },
            () => {}
        );
    }

    change(company: Company) {
        this.openModal(Object.assign({}, company)).then(
            (newCompany: Company) => {
                Object.assign(company, newCompany);
            },
            () => {}
        );
    }

    remove(company: Company) {

        this.modal.confirm(
            'Remove company',
            'Are you sure to remove ' + company.name + '? <b>All users will be removed as well!</b>'
        ).then(
            () => {
                this.api.companies().remove(company.id).subscribe(() => {
                    this.companies.splice(this.companies.indexOf(company), 1);
                });
            },
            () => {

            }
        );
    }

    private openModal(company: Company): Promise<any> {
        let modal = this.modal.custom(CompanyModal);
        modal.componentInstance.companies = this.companies;
        modal.componentInstance.company   = company;

        return modal.result;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/settings/companies/companies.component.ts